var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-grey"},[_vm._v(" "+_vm._s(_vm.$t("asset.total_page_count", { first: _vm.firstItem, last: _vm.lastItem, total: _vm.total, }))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }